import { modalMessages } from 'apps/web_forms/utils/constants';
import Modal from 'apps/web_forms/components/commons/Modal';

export const DeleteDraftSuccessModal = ({ resetSelectedModal }) => {
  return (
    <Modal
      mainMessage={modalMessages.deleteSuccess.main}
      helpTip={modalMessages.deleteSuccess.tip}
      isOpen={true}
      setIsOpen={resetSelectedModal}
      icon='success'
    />
  );
};
